/**
 * MOCK DATA FOR TESTING SUBSCRIPTION FEATURES
 * 
 * HOW TO USE:
 * 1. Set USE_MOCK_DATA = true to enable mock data
 * 2. Choose a test scenario below or create your own
 * 3. Set CURRENT_MOCK_SCENARIO to the scenario you want to test
 * 4. Save the file and the app will use mock data instead of API
 * 
 * REMEMBER: Set USE_MOCK_DATA = false before committing to production!
 */

// ============================================
// TOGGLE THIS FLAG TO ENABLE/DISABLE MOCKING
// ============================================
export const USE_MOCK_DATA = false; // Set to false to use real API

// ============================================
// TEST SCENARIOS
// ============================================

// Scenario 1: Normal student with tests available and analytics enabled
export const SCENARIO_STUDENT_FULL_ACCESS = {
    success: true,
    StatusMsg: "",
    ResponseType: "SUCCESS",
    data: [{
        Id: 194,
        EmailId: "test@yopmail.com",
        FirstName: "Test",
        LastName: "User",
        last_student_subscription_rel_id: 46,
        InstituteId: null,
        Student_sub_PlanName: "Premium",
        Student_sub_NumberOfMocktests: 200,
        Student_sub_BalanceNumberOfMocktests: 50, // Has tests remaining
        Student_sub_ShowAnalytics: 1, // Analytics enabled
        Student_sub_StartDate: "2025-12-30",
        Student_sub_EndDate: "2026-06-30",
        Institute_sub_PlanName: null,
        Institute_sub_NumberOfMocktests: null,
        Institute_sub_BalanceNumberOfMocktests: null,
        Institute_sub_ShowAnalytics: null,
        Institute_sub_StartDate: null,
        Institute_sub_EndDate: null,
    }]
};

// Scenario 2: Normal student with NO tests left
export const SCENARIO_STUDENT_NO_TESTS = {
    success: true,
    StatusMsg: "",
    ResponseType: "SUCCESS",
    data: [{
        Id: 194,
        EmailId: "test@yopmail.com",
        FirstName: "Test",
        LastName: "User",
        last_student_subscription_rel_id: 46,
        InstituteId: null,
        Student_sub_PlanName: "Premium",
        Student_sub_NumberOfMocktests: 200,
        Student_sub_BalanceNumberOfMocktests: 0, // NO TESTS LEFT ❌
        Student_sub_ShowAnalytics: 1,
        Student_sub_StartDate: "2025-12-30",
        Student_sub_EndDate: "2026-06-30",
        Institute_sub_PlanName: null,
        Institute_sub_NumberOfMocktests: null,
        Institute_sub_BalanceNumberOfMocktests: null,
        Institute_sub_ShowAnalytics: null,
        Institute_sub_StartDate: null,
        Institute_sub_EndDate: null,
    }]
};

// Scenario 3: Normal student with NO analytics access
export const SCENARIO_STUDENT_NO_ANALYTICS = {
    success: true,
    StatusMsg: "",
    ResponseType: "SUCCESS",
    data: [{
        Id: 194,
        EmailId: "test@yopmail.com",
        FirstName: "Test",
        LastName: "User",
        last_student_subscription_rel_id: 46,
        InstituteId: null,
        Student_sub_PlanName: "Basic",
        Student_sub_NumberOfMocktests: 50,
        Student_sub_BalanceNumberOfMocktests: 25,
        Student_sub_ShowAnalytics: 0, // NO ANALYTICS ❌
        Student_sub_StartDate: "2025-12-30",
        Student_sub_EndDate: "2026-06-30",
        Institute_sub_PlanName: null,
        Institute_sub_NumberOfMocktests: null,
        Institute_sub_BalanceNumberOfMocktests: null,
        Institute_sub_ShowAnalytics: null,
        Institute_sub_StartDate: null,
        Institute_sub_EndDate: null,
    }]
};

// Scenario 4: Institute student with full access
export const SCENARIO_INSTITUTE_FULL_ACCESS = {
    success: true,
    StatusMsg: "",
    ResponseType: "SUCCESS",
    data: [{
        Id: 194,
        EmailId: "test@yopmail.com",
        FirstName: "Test",
        LastName: "User",
        last_student_subscription_rel_id: null,
        InstituteId: 10,
        Student_sub_PlanName: null,
        Student_sub_NumberOfMocktests: null,
        Student_sub_BalanceNumberOfMocktests: null,
        Student_sub_ShowAnalytics: null,
        Student_sub_StartDate: null,
        Student_sub_EndDate: null,
        Institute_sub_PlanName: "Institute Premium",
        Institute_sub_NumberOfMocktests: 500,
        Institute_sub_BalanceNumberOfMocktests: 300, // Has tests remaining
        Institute_sub_ShowAnalytics: 1, // Analytics enabled
        Institute_sub_StartDate: "2025-12-30",
        Institute_sub_EndDate: "2026-06-30",
    }]
};

// Scenario 5: Institute student with NO tests left
export const SCENARIO_INSTITUTE_NO_TESTS = {
    success: true,
    StatusMsg: "",
    ResponseType: "SUCCESS",
    data: [{
        Id: 194,
        EmailId: "test@yopmail.com",
        FirstName: "Test",
        LastName: "User",
        last_student_subscription_rel_id: null,
        InstituteId: 10,
        Student_sub_PlanName: null,
        Student_sub_NumberOfMocktests: null,
        Student_sub_BalanceNumberOfMocktests: null,
        Student_sub_ShowAnalytics: null,
        Student_sub_StartDate: null,
        Student_sub_EndDate: null,
        Institute_sub_PlanName: "Institute Premium",
        Institute_sub_NumberOfMocktests: 500,
        Institute_sub_BalanceNumberOfMocktests: 0, // NO TESTS LEFT ❌
        Institute_sub_ShowAnalytics: 1,
        Institute_sub_StartDate: "2025-12-30",
        Institute_sub_EndDate: "2026-06-30",
    }]
};

// Scenario 6: Institute student with NO analytics access
export const SCENARIO_INSTITUTE_NO_ANALYTICS = {
    success: true,
    StatusMsg: "",
    ResponseType: "SUCCESS",
    data: [{
        Id: 194,
        EmailId: "test@yopmail.com",
        FirstName: "Test",
        LastName: "User",
        last_student_subscription_rel_id: null,
        InstituteId: 10,
        Student_sub_PlanName: null,
        Student_sub_NumberOfMocktests: null,
        Student_sub_BalanceNumberOfMocktests: null,
        Student_sub_ShowAnalytics: null,
        Student_sub_StartDate: null,
        Student_sub_EndDate: null,
        Institute_sub_PlanName: "Institute Basic",
        Institute_sub_NumberOfMocktests: 100,
        Institute_sub_BalanceNumberOfMocktests: 50,
        Institute_sub_ShowAnalytics: 0, // NO ANALYTICS ❌
        Institute_sub_StartDate: "2025-12-30",
        Institute_sub_EndDate: "2026-06-30",
    }]
};

// Scenario 7: Student with NO tests AND NO analytics (worst case)
export const SCENARIO_STUDENT_NO_ACCESS = {
    success: true,
    StatusMsg: "",
    ResponseType: "SUCCESS",
    data: [{
        Id: 194,
        EmailId: "test@yopmail.com",
        FirstName: "Test",
        LastName: "User",
        last_student_subscription_rel_id: 46,
        InstituteId: null,
        Student_sub_PlanName: "Basic",
        Student_sub_NumberOfMocktests: 10,
        Student_sub_BalanceNumberOfMocktests: 0, // NO TESTS ❌
        Student_sub_ShowAnalytics: 0, // NO ANALYTICS ❌
        Student_sub_StartDate: "2025-12-30",
        Student_sub_EndDate: "2026-06-30",
        Institute_sub_PlanName: null,
        Institute_sub_NumberOfMocktests: null,
        Institute_sub_BalanceNumberOfMocktests: null,
        Institute_sub_ShowAnalytics: null,
        Institute_sub_StartDate: null,
        Institute_sub_EndDate: null,
    }]
};

// Scenario 8: Student with EXPIRED subscription
export const SCENARIO_STUDENT_EXPIRED = {
    success: true,
    StatusMsg: "",
    ResponseType: "SUCCESS",
    data: [{
        Id: 220,
        EmailId: "expired@yopmail.com",
        DOB: null,
        FirstName: "Expired",
        LastName: "Student",
        NickName: "",
        ProfileImage: null,
        ProfileImageUrl: null,
        PhoneNo: "9876543210",
        CountryCode: "+91",
        Gender: null,
        City: "Mumbai",
        Address: null,
        stateId: 19,
        cityId: 1156,
        LanguageId: 1,
        stateName: "MAHARASHTRA",
        cityName: "Mumbai",
        School: null,
        last_student_subscription_rel_id: 64,
        InstituteId: null,
        Student_sub_PlanName: "Premium",
        Student_sub_NumberOfMocktests: 200,
        Student_sub_BalanceNumberOfMocktests: 150,
        Student_sub_ShowAnalytics: 1,
        Student_sub_StartDate: "2024-01-01",
        Student_sub_EndDate: "2026-01-19", // EXPIRED ❌
        Institute_sub_PlanName: null,
        Institute_sub_NumberOfMocktests: null,
        Institute_sub_BalanceNumberOfMocktests: null,
        Institute_sub_BalanceNoOfStudents: null,
        Institute_sub_NoOfStudents: null,
        Institute_sub_ShowAnalytics: null,
        Institute_sub_StartDate: null,
        Institute_sub_EndDate: null,
        Institutelogoimageurl: null
    }]
};

// Scenario 9: Institute student with EXPIRED subscription
export const SCENARIO_INSTITUTE_EXPIRED = {
    success: true,
    StatusMsg: "",
    ResponseType: "SUCCESS",
    data: [{
        Id: 221,
        EmailId: "institute.expired@yopmail.com",
        DOB: null,
        FirstName: "Institute",
        LastName: "Student",
        NickName: "",
        ProfileImage: null,
        ProfileImageUrl: null,
        PhoneNo: "8765432109",
        CountryCode: "+91",
        Gender: null,
        City: "Delhi",
        Address: null,
        stateId: 7,
        cityId: 110,
        LanguageId: 1,
        stateName: "DELHI",
        cityName: "Delhi",
        School: null,
        last_student_subscription_rel_id: null,
        InstituteId: 15,
        Student_sub_PlanName: null,
        Student_sub_NumberOfMocktests: null,
        Student_sub_BalanceNumberOfMocktests: null,
        Student_sub_ShowAnalytics: null,
        Student_sub_StartDate: null,
        Student_sub_EndDate: null,
        Institute_sub_PlanName: "Institute Premium",
        Institute_sub_NumberOfMocktests: 1000,
        Institute_sub_BalanceNumberOfMocktests: 800,
        Institute_sub_BalanceNoOfStudents: 45,
        Institute_sub_NoOfStudents: 50,
        Institute_sub_ShowAnalytics: 1,
        Institute_sub_StartDate: "2024-01-01",
        Institute_sub_EndDate: "2026-1-31", // EXPIRED ❌
        Institutelogoimageurl: null
    }]
};

// ============================================
// SELECT WHICH SCENARIO TO USE
// ============================================
export const CURRENT_MOCK_SCENARIO = SCENARIO_STUDENT_EXPIRED;

// Change to any scenario above:
// - SCENARIO_STUDENT_FULL_ACCESS
// - SCENARIO_STUDENT_NO_TESTS
// - SCENARIO_STUDENT_NO_ANALYTICS
// - SCENARIO_INSTITUTE_FULL_ACCESS
// - SCENARIO_INSTITUTE_NO_TESTS
// - SCENARIO_INSTITUTE_NO_ANALYTICS
// - SCENARIO_STUDENT_NO_ACCESS
// - SCENARIO_STUDENT_EXPIRED
// - SCENARIO_INSTITUTE_EXPIRED

/**
 * Helper function to get mock user details
 * This mimics the API response structure
 */
export const getMockUserDetails = () => {
    return new Promise((resolve) => {
        // Simulate API delay
        setTimeout(() => {
            resolve(CURRENT_MOCK_SCENARIO);
        }, 500); // 500ms delay to simulate network
    });
};
